module.exports = __webpack_public_path__ + "img/pickTwo.ab834099.webp";